import { CaseStudyType } from '@/utils/types'

const labels: Record<CaseStudyType, string> = {
  [CaseStudyType.Postgres]: 'Postgres',
  [CaseStudyType.Vitess]: 'Vitess'
}

export const caseStudyLabel = (type: CaseStudyType) => labels[type]
